export class Modal {
  constructor() {
    this.modal = document.querySelector('.js-modal')
    this.iframe = document.querySelector('.js-modal-iframe')
    this.openBtn = document.querySelector('.js-modal-open')
    this.closeBtns = document.querySelectorAll('.js-modal-close')

    if (!this.modal || !this.iframe || !this.openBtn) return
    this.init()
  }

  init() {
    this.openBtn.addEventListener('click', () => this.open())
    this.closeBtns.forEach((btn) => btn.addEventListener('click', () => this.close()))
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close()
    })
  }

  open() {
    // 初回だけsrcをセット
    if (!this.iframe.src || this.iframe.src === window.location.href) {
      this.iframe.src = this.iframe.dataset.src
    }
    this.modal.classList.add('is-open')
    this.modal.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'
  }

  close() {
    this.modal.classList.remove('is-open')
    this.modal.setAttribute('aria-hidden', 'true')
    document.body.style.overflow = ''
  }
}
